<div
	class="text-secondary dark:text-secondary-900 left-0 absolute right-0 duration-300 flex flex-col max-h-[calc(100vh-4rem)]"
	[style.top]="positionTop()"
	#subNav
>
	<div class="flex pl-6 items-center h-10 shrink-0">
		<ui-headline
			type="h3"
			class="-mb-3"
			[class]="{
				'text-secondary-800': navColor() === 'dark',
				'text-primary-700': navColor() === 'primary',
				'text-white': navColor() === 'light',
			}"
			><span class="flex items-center gap-2"
				>{{ menuItem()?.name ?? '' }}
				@if (menuItem()?.beta) {
					<ui-tag text="BETA" type="dark"></ui-tag>
				}</span
		></ui-headline>
	</div>
	<div class="flex-1 min-h-0 overflow-y-auto">
		@if (menuItem() && menuItem()?.submenus) {
			@for (subMenu of getSubmenus(menuItem()!); let i = $index; track i) {
				@if (subMenu.dividers) {
					<div class="px-6 py-2">
						<ui-divider [noMargin]="true"></ui-divider>
					</div>
				}
				@if (isRouteItem(subMenu)) {
					<a
						class="cursor-pointer min-h-10 duration-300 py-2 px-6 outline-none focus-visible-border focus-visible:rounded-sm border-2 border-transparent w-full text-left flex items-center gap-2"
						[routerLink]="subMenu.url"
						(click)="clickItem(subMenu)"
						[attr.data-cy]="'subnav-item-' + (subMenu.url || subMenu.name)"
						[attr.data-sub-nav-item]="i"
						[uiTooltip]="subMenu.tooltip ?? ''"
						[class]="{
							'text-secondary-800': navColor() === 'dark',
							'text-primary-700': navColor() === 'primary',
							'text-white': navColor() === 'light',
							'hover:bg-primary-300!': !subMenu.disabled,
							'bg-primary-200': isSubmenuActive(subMenu),
							'font-semibold': subMenu.dividers,
						}"
					>
						<ng-container
							[ngTemplateOutlet]="subMenuContent"
							[ngTemplateOutletContext]="{ $implicit: subMenu }"
						></ng-container>
					</a>
				} @else {
					<button
						class="cursor-pointer min-h-10 duration-300 py-2 px-6 outline-none focus-visible-border focus-visible:rounded-sm border-2 border-transparent w-full text-left flex items-center gap-2"
						(click)="clickItem(subMenu)"
						[disabled]="subMenu.disabled"
						[attr.data-cy]="'subnav-item-' + (subMenu.url || subMenu.name)"
						[attr.data-sub-nav-item]="i"
						[uiTooltip]="subMenu.tooltip ?? ''"
						[class]="{
							'text-secondary-800': navColor() === 'dark',
							'text-primary-700': navColor() === 'primary',
							'text-white': navColor() === 'light',
							'text-secondary-400!': subMenu.disabled,
							'hover:cursor-not-allowed!': subMenu.disabled,
							'hover:bg-primary-100': subMenu.disabled,
							'hover:bg-primary-300!': !subMenu.disabled,
							'bg-primary-200': isSubmenuActive(subMenu),
							'font-semibold': subMenu.dividers,
						}"
					>
						<ng-container
							[ngTemplateOutlet]="subMenuContent"
							[ngTemplateOutletContext]="{ $implicit: subMenu }"
						></ng-container>
					</button>
				}
				@if (subMenu.dividers) {
					<div class="px-6 py-2">
						<ui-divider [noMargin]="true"></ui-divider>
					</div>
				}
			}
		}
	</div>
</div>

<ng-template #subMenuContent let-subMenu>
	<span class="flex items-center gap-2 min-w-0">
		<span class="line-clamp-2 break-words min-w-0 w-full">{{ subMenu.name }}</span>
		@if (subMenu.beta) {
			<ui-tag text="BETA" type="dark"></ui-tag>
		}
	</span>
	@if (subMenu.icon) {
		<ui-icon
			class="ml-auto"
			[disabled]="subMenu.disabled ?? false"
			[icon]="subMenu.icon"
			size="s"
			[type]="navColor()"
			aria-hidden="true"
		>
		</ui-icon>
	}
</ng-template>
